import { createFileRoute, redirect } from "@tanstack/react-router";

import { DashboardPage } from "@/features/dashboard/DashboardPage";

/**
 * Members see their own work in My tasks; the overview is for the people who
 * run projects. The replica already limits what anyone can see, so this is a
 * question of what is useful on screen, not of access.
 */
export const Route = createFileRoute("/_app/dashboard")({
  beforeLoad: ({ context }) => {
    if (context.me.user.role === "member") throw redirect({ to: "/my-tasks" });
  },
  component: DashboardPage,
});
